import React from 'react'

const AddNewproduct = () => {
  return (
    <div>AddNewproduct</div>
  )
}

export default AddNewproduct